<template>
  <div>
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container">
        <div class="navbar-header">
          <button
            type="button"
            class="navbar-toggle"
            data-toggle="collapse"
            data-target="#navigation-example-2"
            @click="toggleNavbar"
          >
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <router-link
            class="navbar-brand"
            to="/admin"
          ><img
              :src="logo"
              alt="TEFL Org Logo"
              width="150"
            ></router-link>
        </div>

      </div>
    </nav>

    <div class="wrapper wrapper-full-page">
      <div
        class="full-page login-page"
        data-color=""
        data-image="static/img/background/bg.jpg"
      >
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3">
                <div
                  class="card"
                  data-background="color"
                  data-color="blue"
                >
                  <el-tabs
                    type="border-card"
                    v-model="activeTab"
                  >
                    <el-tab-pane
                      label="Employee Login"
                      name="employee"
                      :disabled="tutor"
                    >
                      <form
                        method="#"
                        action="#"
                        @submit.prevent="login"
                      >
                        <div
                          class=""
                          data-background="color"
                          data-color="blue"
                        >
                          <div class="card-header">
                            <h3 class="card-title">Employee Login</h3>
                          </div>
                          <div class="card-content">
                            <div
                              v-if="error"
                              @hide="hideError"
                              class="alert alert-danger"
                            >
                              <button
                                type="button"
                                class="close"
                                v-on:click="hideError()"
                              >×</button>
                              <span>
                                <b> Error - </b> Your username or password is incorrect</span>
                            </div>
                            <div class="form-group">
                              <label>Username</label>
                              <input
                                required
                                @focus="hideError()"
                                v-model="username"
                                type="text"
                                placeholder="Enter email"
                                class="form-control input-no-border"
                              >
                            </div>
                            <div class="form-group">
                              <label>Password</label>
                              <input
                                required
                                @focus="hideError()"
                                v-model="password"
                                type="password"
                                placeholder="Password"
                                class="form-control input-no-border"
                              >
                            </div>
                          </div>
                          <div class="card-footer text-center">
                            <button
                              type="submit"
                              class="btn btn-fill btn-wd "
                            >Login</button>
                          </div>
                        </div>
                      </form>
                    </el-tab-pane>
                    <el-tab-pane
                      label="Tutor Login"
                      name="tutor"
                    >
                      <form
                        method="#"
                        action="#"
                        @submit.prevent="tutorLogin"
                      >
                        <div
                          class=""
                          data-background="color"
                          data-color="blue"
                        >
                          <div class="card-header">
                            <h3 class="card-title">Tutor Login</h3>
                          </div>
                          <div class="card-content">
                            <div
                              v-if="error"
                              @hide="hideError"
                              class="alert alert-danger"
                            >
                              <button
                                type="button"
                                class="close"
                                v-on:click="hideError()"
                              >×</button>
                              <span>
                                <b> Error - </b> Your username or password is incorrect</span>
                            </div>
                            <div class="form-group">
                              <label>Username</label>
                              <input
                                required
                                @focus="hideError()"
                                v-model="username"
                                type="text"
                                placeholder="Enter email"
                                class="form-control input-no-border"
                              >
                            </div>
                            <div class="form-group">
                              <label>Password</label>
                              <input
                                required
                                @focus="hideError()"
                                v-model="password"
                                type="password"
                                placeholder="Password"
                                class="form-control input-no-border"
                              >
                            </div>
                          </div>
                          <div class="card-footer text-center">
                            <button
                              type="submit"
                              class="btn btn-fill btn-wd "
                            >Tutor Login</button>
                          </div>
                        </div>
                      </form>
                    </el-tab-pane>
                  </el-tabs>
                </div>

              </div>
            </div>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright">
              &copy; Coded with
              <i class="fa fa-heart heart"></i> by
              <a
                href="https://www.tefl.org/"
                target="_blank"
              >TEFL Org</a>.
            </div>
          </div>
        </footer>
        <div
          class="full-page-background"
          style="background-image: url(static/img/background/bg.jpg) "
        ></div>

      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <router-link
          to="/register"
          tag="li"
        >
          <a>Register</a>
        </router-link>
        <router-link
          to="/admin/overview"
          tag="li"
        >
          <a>Dashboard</a>
        </router-link>
      </ul>
    </div>
  </div>
</template>

<script>
import { AUTH_REQUEST, AUTH_REQUEST_TUTOR } from '../../store/actions/auth'
import { USER_REQUEST,GET_USERS,GET_ROLE  } from '../../store/actions/user'
export default {
  props: {
      logo: {
        type: String,
        default: 'static/img/TEFL-Logo-White.svg'
      }
  },
  data () {
    return {
      username: '',
      password: '',
      activeTab:'employee',
      tutor:false,
      error: false
    }
  },
  methods: {
    login: function () {   
      const { username, password } = this;
      this.$store.dispatch(AUTH_REQUEST, { username, password })
      .then((resp) => {
       if (this.$store.getters.isAuthenticated){
       this.$store.dispatch(USER_REQUEST);
      // This is to store other users to save returning to the database
      ///this.$store.dispatch(USER_REQUEST)
      
                  console.log('data:', resp)
                  if (resp.data.user_role==='tutor'){
                    this.$router.push({path:'/tutor'})
                  }else{
                    this.$router.push('/')
                  }
  
            }
      })
      .catch(() => {
        this.error = true
      })
    
    },
    tutorLogin: function () {   
      const { username, password } = this;
      this.$store.dispatch(AUTH_REQUEST_TUTOR, { username, password })
      .then((resp) => {
       if (this.$store.getters.isAuthenticated) {
      this.$store.dispatch(USER_REQUEST)
      // This is to store other users to save returning to the database
      //this.$store.dispatch(GET_USERS)
                  console.log('data:', resp)
                  this.$router.push({path:'/tutors/dashboard'})
  
       }
      })
      .catch(() => {
        this.error = true
      })
    },
    hideError() {
        this.error = false
    },
    toggleNavbar() {
      document.body.classList.toggle('nav-open')
    },
    closeMenu() {
      document.body.classList.remove('nav-open')
      document.body.classList.remove('off-canvas-sidebar')
    },
  beforeDestroy() {
    this.error = false;
    this.closeMenu();
  
  }
},
  mounted() {
    if (this.$route.path == "/tutor") {
      console.log(this.$route.path);
      this.activeTab = "tutor";
      this.tutor = true;
    } else {
      this.activeTab = "employee";
    }
  },
  watch: {
    "$route": function(route) {
      console.log("watching...,",route);
      //this.getOrder(id);
      if (route.path == "/tutor") {
        console.log(this.$route.path);
        this.activeTab = "tutor";
        this.tutor = true;
      } else {
        this.activeTab = "employee";
        this.tutor=false
      }
    }
  }
    
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/Login/Login.vue